import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ArtistRegistration.html?raw';
import _StatefulBase from '../../moreCore/UI/_StatefulBase/_StatefulBase';
import Edit from '../../moreCore/UI/Edit/Edit';
import '../../moreCore/UI/Edit/Edit';
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import '../../moreCore/UI/SelectBox/SelectBox';
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';
import '../../moreCore/UI/RadioGroup/RadioGroup';
import '../../moreCore/UI/EntityBased/HintBox/HintBox';
import PhoneInput from '../../moreCore/UI/PhoneInput/PhoneInput';
import '../../moreCore/UI/PhoneInput/PhoneInput';
import FileUpload from '../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import '../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import '../../moreCore/UI/NumberInput/NumberInput';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import '../../moreCore/UI/GenericDialog/GenericDialog';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import '../../moreCore/UI/CheckBox/CheckBox';
import '../../moreCore/UI/SelectBox/SelectBox';
import organisationMember from './organisationMember/organisationMember';
import "./organisationMember/organisationMember";
import IbanInput from './IbanInput/IbanInput';
import './IbanInput/IbanInput';
import './AddressBlock_generic/AddressBlock_generic';
import AR_AddressBlock from './AddressBlock/AddressBlock';


interface Country {
    name: string,
    iso2: string,
    dialCode:string
}
class ArtistRegistration extends compose(_WidgetBaseSP) {
    templateString: any = template;

    Edit_otherAddressInformation: HTMLElement;
    Edit_otherAddressInformation2: HTMLElement;
    Edit_otherAddressInformation3: HTMLElement;
    Edit_otherAddressInformation_tax: HTMLElement;
    Edit_otherAddressInformation_tax2: HTMLElement;
    Edit_otherAddressInformation_tax3: HTMLElement;
    Edit_organizationName: HTMLElement;


    //-------------------------------------------------- umbau

    // ContainerNodes for Inputs -------------------------------------START
    DataForm: HTMLElement; // the Container Card
    RadioGroup_isOrganization: HTMLElement;
    SelectBox_gender: HTMLElement;
    Edit_NobilityPredicate: HTMLElement;
    Edit_nameSuffix: HTMLElement;
    Edit_PersonTitle: HTMLElement;
    Edit_name: HTMLElement;
    Edit_namePreposition: HTMLElement;
    Edit_surname: HTMLElement;
    Edit_artistName: HTMLElement;

    CheckBox_isTaxAddress_residenceAddress: HTMLElement;
    addressData_residence_container: HTMLElement;
    addressData_tax_container: HTMLElement;

    phoneInput_phone_mobile: HTMLElement;
    phoneInput_phone_landLine: HTMLElement;
    Edit_phone_other: HTMLElement;

    Edit_email: HTMLElement;
    Edit_email_2: HTMLElement;

    Edit_taxNumber: HTMLElement;
    Edit_UID: HTMLElement;
    Edit_otherTaxId_type: HTMLElement;
    Edit_otherTaxId_number: HTMLElement;

    Edit_AccountHolder: HTMLElement;
    RadioGroup_isIBAN_Account: HTMLElement;
    IbanInput_IBAN: HTMLElement;
    Edit_bankName: HTMLElement;
    Edit_BankAddress: HTMLElement;
    Edit_BankAccNumber: HTMLElement;
    Edit_BIC_SWIFT: HTMLElement;
    Edit_RoutingNumber: HTMLElement;
    Edit_otherBankInformation: HTMLElement;
    Edit_AccountHolder_row: HTMLElement;

    Textarea_miscellaneous: HTMLElement;

    FileUpload_documents: HTMLElement;
    FileUpload_passport: HTMLElement;

    CheckBox_newsletter: HTMLElement;
    CheckBox_dataProcessing: HTMLElement;

    ifNotTaxAdress_isResidenceAdress: HTMLElement;
    ifNotIBAN: HTMLElement;
    organisationMember_container: HTMLElement;
    Edit_web: HTMLElement;

    Edit_legalRegistrationInstitution: HTMLElement;
    Edit_legalRegistrationNumber: HTMLElement;
    header_person: HTMLElement;
    header_organisation: HTMLElement;
    legalRegistration_container: HTMLElement;
    header_address: HTMLElement;
    header_phoneEmail: HTMLElement;
    header_phoneEmailWeb: HTMLElement;
    Edit_taxId_german: HTMLElement;
    otherTaxId_container: HTMLElement;
    CheckBox_isVAT: HTMLElement;
    Edit_reasonForVATExc: HTMLElement;
    VAT_container: HTMLElement;
    privatPersonContainer: HTMLElement;
    contactDetails_person_container: HTMLElement;
    phoneInput_phone_organization_central: HTMLElement;
    organisationMember_header: HTMLElement;
    fileUpload_container: HTMLElement;
    taxDataHeader_person: HTMLElement;
    taxDataHeader_organisation: HTMLElement;
    bankAccountHeader_person: HTMLElement;
    bankAccountHeader_organisation: HTMLElement;
    addressHeader_person: HTMLElement;
    addressHeader_organisation: HTMLElement;
    SelectBox_notax_type: HTMLElement;


    // ContainerNodes for Inputs ------------------------END

    selectLangButton: HTMLButtonElement;
    train_bonus_card_type: MdsLax<InstanceType<typeof SelectBox>>;
    miscellaneous: HTMLTextAreaElement;

    // Inputs ----------------------------------------START

    personTitle: MdsLax<InstanceType<typeof Edit>>;
    firstName: MdsLax<InstanceType<typeof Edit>>;
    otherNames: MdsLax<InstanceType<typeof Edit>>;
    namePreposition: MdsLax<InstanceType<typeof Edit>>;
    surname: MdsLax<InstanceType<typeof Edit>>;
    artistName: MdsLax<InstanceType<typeof Edit>>;
    taxNumber: MdsLax<InstanceType<typeof Edit>>;
    UID: MdsLax<InstanceType<typeof Edit>>;
    email: MdsLax<InstanceType<typeof Edit>>;
    AccountHolder: MdsLax<InstanceType<typeof Edit>>;
    IBAN: MdsLax<InstanceType<typeof IbanInput>>;
    bankName: MdsLax<InstanceType<typeof Edit>>;
    bankAddress: MdsLax<InstanceType<typeof Edit>>;
    bankAccNumber: MdsLax<InstanceType<typeof Edit>>;
    BIC_SWIFT: MdsLax<InstanceType<typeof Edit>>;
    routingNumber: MdsLax<InstanceType<typeof Edit>>;
    otherBankInformation: MdsLax<InstanceType<typeof Edit>>;
    organizationName: MdsLax<InstanceType<typeof Edit>>;
    nobilityPredicate: MdsLax<InstanceType<typeof Edit>>;
    nameSuffix: MdsLax<InstanceType<typeof Edit>>;
    email_2: MdsLax<InstanceType<typeof Edit>>;
    otherTaxId_type: MdsLax<InstanceType<typeof Edit>>;
    otherTaxId_number: MdsLax<InstanceType<typeof Edit>>;
    company_otherTaxId_type: MdsLax<InstanceType<typeof Edit>>;
    company_otherTaxId_number: MdsLax<InstanceType<typeof Edit>>;
    web: MdsLax<InstanceType<typeof Edit>>;
    legalRegistrationInstitution: MdsLax<InstanceType<typeof Edit>>;
    legalRegistrationNumber: MdsLax<InstanceType<typeof Edit>>;
    reasonForVATExc: MdsLax<InstanceType<typeof Edit>>;
    taxId_german: MdsLax<InstanceType<typeof Edit>>;

    isOrganization: MdsLax<InstanceType<typeof RadioGroup>>;
    isIBAN_Account: MdsLax<InstanceType<typeof RadioGroup>>;

    phone_mobile: PhoneInput;
    phone_landLine: PhoneInput;
    phone_organization_central: PhoneInput;
    phone_other: PhoneInput;


    documents_upload: MdsLax<InstanceType<typeof FileUpload>>;
    passport_upload: MdsLax<InstanceType<typeof FileUpload>>;

    isTaxAddress_residenceAddress: MdsLax<InstanceType<typeof CheckBox>>;
    isVAT: MdsLax<InstanceType<typeof CheckBox>>;
    newsletter: MdsLax<InstanceType<typeof CheckBox>>;
    dataProcessing: MdsLax<InstanceType<typeof CheckBox>>;
    addressData_residence: MdsLax<InstanceType<typeof AR_AddressBlock>>;
    addressData_tax: MdsLax<InstanceType<typeof AR_AddressBlock>>;

    organisationMember: MdsLax<InstanceType<typeof organisationMember>>;

    gender: MdsLax<InstanceType<typeof SelectBox>>;
    language: MdsLax<InstanceType<typeof SelectBox>>;
    taxrate: MdsLax<InstanceType<typeof SelectBox>>;
    notax_type: MdsLax<InstanceType<typeof SelectBox>>;

    // Inputs ----------------------------------------- END

    // Properties -------------------------------------START

    personName: string;
    personSurname: string;
    defaultCountrySelect: string;
    validationGUID: string;

    selectedLanguage: string;

    __request: dojo.request.Promise<any>;

    controllerUrl: string = "ArtistRegistration/SaveFormData";

    allValues: object = {};
    _submitTimeout: number = null;


    // um daten auf Vollzähligkeit zu prüfen
    mandataoryFields: Array<string> = ["addressData_tax", "dataProcessing"];
    taxAddress_IsNot_ResidenceAdress_Fields: Array<string> = ["addressData_residence"];
    organization_fields: Array<string> = ["organisationMember" ];
    person_fields: Array<string> = ["gender", "firstName", "surname"];
    germanOrganisation_fields: Array<string> = ["taxNumber", "legalRegistrationInstitution"];

    //Für Organisation und Person sind vreschiedene datensätze vorgesehen, daher passen wir den allValuesObj gemäß dem Auswahl an
    fieldsToDelete_ifOrganisation: Array<string> = ["gender", "personTitle", "nobilityPredicate", "firstName", "namePreposition", "surname", "nameSuffix", "artistName", "phone_mobile", "phone_landLine",
        "phone_other", "email_2"];
    fieldsToDelete_ifPerson: Array<string> = ["organizationName", "phone_organization_central", "web", "legalRegistrationInstitution", "legalRegistrationNumber", "organisationMember"];

    // to get the confirmation diaöog field in the right order
    allDataProperties: Array<string> = ["language", "isOrganization", "gender", "personTitle", "nobilityPredicate", "firstName", "namePreposition", "surname", "nameSuffix", "artistName", "organizationName",
        "addressData_tax", "addressData_residence", "authorizedRepresentatives", "phone_mobile", "phone_landLine", "phone_other", "phone_organization_central", "email", "email_2", "web", "taxNumber", "taxId_german", "UID", "otherTaxId_type", "otherTaxId_number", "isVAT",
        "reasonForVATExc", "legalRegistrationInstitution", "legalRegistrationNumber", "AccountHolder", "IBAN", "BIC_SWIFT", "bankAccNumber", "bankName", "routingNumber", "bankAddress", "otherBankInformation", "organisationMember", "miscellaneous", "train_bonus_card_type",  "passport_upload", "documents_upload", "newsletter", "taxrate"/*, "notax_type"*/];

    // Properties -------------------------------------END

    // Laanguage ----------------------------------------START

    beforeOnloadEventFunction: any = function (event) {
        event.returnValue = "";
    };

    _onChangeSelectLang(evt?: Event): void {

        if (this.language.getValue() != this.selectedLanguage) {
            this.changeLanguage();
        }

/*
        if (this.selectedLanguage == "de") {
            this.UiModder.domClass.remove(this.Edit_taxId_german, "w3-hide");
            this.UiModder.domClass.remove(this.VAT_container, "w3-hide");
            this.addValue(this.isVAT);
        } else {
            this.UiModder.domClass.add(this.Edit_taxId_german, "w3-hide");
            this.UiModder.domClass.add(this.VAT_container, "w3-hide");
            delete this.allValues["isVAT"];
        }
*/
    }

    changeLanguage(): void {

        let urlParam: string = this.language.getValue();

        this.setUrlParameter("lang", urlParam);
        location.reload();
    }

    setLanguageSelect(value?: string): void {

        let urlValue = this.getUrlParameterValue("lang");

        if (value) {
            if (value == "de" || value == "en") {
                this.selectedLanguage = value
            } else {
                alert("invalid language parameter")
            }
        } else if (urlValue){
            this.selectedLanguage = urlValue;
        }

        if (this.selectedLanguage) {
            this.language.setValue(this.selectedLanguage);
            this.allValues[this.getAttachPointNameForWidget(this.language)] = this.language.getValue();
        }
    }


    // Laanguage ----------------------------------------END


    // Events ----------------------------------------- START


    _onChange_isOrganization(): void {
        this.addValue(this.isOrganization);

        if (this.isOrganization.getValue() == "person") {

            //this.taxNumber.setLabel(this.translations["ArtistRegistration__taxNumber"]);
            this.taxNumber.setMandatory(false);
            this.legalRegistrationInstitution.setMandatory(false);

            this.UiModder.domClass.remove(this.privatPersonContainer, "w3-hide");
            this.firstName.setMandatory(true);
            this.surname.setMandatory(true);

            this.UiModder.domClass.add(this.Edit_web, "w3-hide");
            this.UiModder.domClass.remove(this.Edit_email_2, "w3-hide");
            this.UiModder.domClass.add(this.header_organisation, "w3-hide");
            this.UiModder.domClass.remove(this.header_person, "w3-hide");
            this.UiModder.domClass.add(this.Edit_organizationName, "w3-hide");
            this.UiModder.domClass.add(this.legalRegistration_container, "w3-hide");
            this.UiModder.domClass.add(this.header_phoneEmailWeb, "w3-hide");
            this.UiModder.domClass.remove(this.header_phoneEmail, "w3-hide");
            this.UiModder.domClass.add(this.taxDataHeader_organisation, "w3-hide");
            this.UiModder.domClass.remove(this.taxDataHeader_person, "w3-hide");
            this.UiModder.domClass.add(this.addressHeader_organisation, "w3-hide");
            this.UiModder.domClass.remove(this.addressHeader_person, "w3-hide");
            this.UiModder.domClass.add(this.bankAccountHeader_organisation, "w3-hide");
            this.UiModder.domClass.remove(this.bankAccountHeader_person, "w3-hide");


            if (this.selectedLanguage == "de") {
                //this.UiModder.domClass.remove(this.VAT_container, "w3-hide");
                //this.UiModder.domClass.remove(this.Edit_taxId_german, "w3-hide");
            }


            this.UiModder.domClass.remove(this.otherTaxId_container, "w3-hide");

            this.UiModder.domClass.remove(this.contactDetails_person_container, "w3-hide");
            this.UiModder.domClass.add(this.phoneInput_phone_organization_central, "w3-hide");
            this.UiModder.domClass.remove(this.Edit_email_2, "w3-hide");

            this.UiModder.domClass.add(this.organisationMember_container, "w3-hide");
            this.organisationMember.setMandatory(false);
            this.UiModder.domClass.add(this.organisationMember_header, "w3-hide");

            this._sanitiseAllValues();


        } else {

            /*if (this.selectedLanguage == "de") {
                this.taxNumber.setLabel(this.taxNumber.getLabel() + " *");
                this.taxNumber.setMandatory(true);
                this.legalRegistrationInstitution.setMandatory(true);
            }*/

            this.UiModder.domClass.add(this.privatPersonContainer, "w3-hide");
            this.firstName.setMandatory(false);
            this.surname.setMandatory(false);

            this.UiModder.domClass.remove(this.Edit_web, "w3-hide");
            this.UiModder.domClass.add(this.Edit_email_2, "w3-hide");
            this.UiModder.domClass.remove(this.header_organisation, "w3-hide");
            this.UiModder.domClass.add(this.header_person, "w3-hide");
            this.UiModder.domClass.remove(this.Edit_organizationName, "w3-hide");
            this.UiModder.domClass.remove(this.legalRegistration_container, "w3-hide");
            this.UiModder.domClass.remove(this.header_phoneEmailWeb, "w3-hide");
            this.UiModder.domClass.add(this.header_phoneEmail, "w3-hide");
            this.UiModder.domClass.remove(this.taxDataHeader_organisation, "w3-hide");
            this.UiModder.domClass.add(this.taxDataHeader_person, "w3-hide");
            this.UiModder.domClass.remove(this.addressHeader_organisation, "w3-hide");
            this.UiModder.domClass.add(this.addressHeader_person, "w3-hide");
            this.UiModder.domClass.remove(this.bankAccountHeader_organisation, "w3-hide");
            this.UiModder.domClass.add(this.bankAccountHeader_person, "w3-hide");

            //this.UiModder.domClass.add(this.VAT_container, "w3-hide");
            this.UiModder.domClass.add(this.Edit_taxId_german, "w3-hide");
            this.UiModder.domClass.add(this.otherTaxId_container, "w3-hide");

            this.UiModder.domClass.add(this.contactDetails_person_container, "w3-hide");
            this.UiModder.domClass.remove(this.phoneInput_phone_organization_central, "w3-hide");
            this.UiModder.domClass.add(this.Edit_email_2, "w3-hide");

            this.UiModder.domClass.remove(this.organisationMember_container, "w3-hide");
            this.UiModder.domClass.remove(this.organisationMember_header, "w3-hide");
            this.organisationMember.setMandatory(true);

            this._sanitiseAllValues();
        }
    }

    _sanitiseAllValues(): void {
        if (this.isOrganization.getValue() == "person") {
            // separat weil nur für deutsche Personen
            /*if (this.selectedLanguage == "de") {
                this.addValue(this.isVAT);
                this.addValue(this.reasonForVATExc);
            }*/

            // Alle Organisationsproperties aus this.allValues löschen
            for (let organisationProperty of this.fieldsToDelete_ifPerson) {
                if (organisationProperty in this.allValues) {
                    delete this.allValues[organisationProperty];
                }
            }
            // alle personenProperties hinzufügen
            for (let personProperty of this.fieldsToDelete_ifOrganisation) {
                this.addValue(this[personProperty]);
            }
        } else {
            //separat weil nur für deutsche Personen
            delete this.allValues["isVAT"];
            delete this.allValues["reasonForVATExc"];

            // Alle Organisationsproperties zinzufügen
            for (let organisationProperty of this.fieldsToDelete_ifPerson) {
                this.addValue(this[organisationProperty]);
            }
            // alle personenProperties aus this.allValues löschen
            for (let personProperty of this.fieldsToDelete_ifOrganisation) {
                if (personProperty in this.allValues) {
                    delete this.allValues[personProperty];
                }
            }
        }
    }

    _onChange_gender(): void {
        this.addValue(this.gender);

    }

    _onChange_taxrate(): void {
        let selectedTaxRate = this.taxrate.getValue();

        if(selectedTaxRate == 'Sonst' ){
            //this.UiModder.domClass.remove(this.SelectBox_notax_type, "w3-hide");
            this.UiModder.domClass.remove(this.Edit_reasonForVATExc, "w3-hide");
        }else{
            //this.UiModder.domClass.add(this.SelectBox_notax_type, "w3-hide");
            this.UiModder.domClass.add(this.Edit_reasonForVATExc, "w3-hide");
        }

        this.addValue(this.taxrate);
        this.addValue(this.notax_type);
    }

    _onChange_notax_type(): void {

        let selectedTaxRateType = this.notax_type.getValue();
        //console.log("selectedTaxRateType", selectedTaxRateType);
        this.addValue(this.notax_type);

        if (selectedTaxRateType == "other") {
            this.UiModder.domClass.remove(this.Edit_reasonForVATExc, "w3-hide");
            this.addValue(this.reasonForVATExc);
        } else {
            this.UiModder.domClass.add(this.Edit_reasonForVATExc, "w3-hide");
            delete this.allValues["reasonForVATExc"];
        }


        this.addValue(this.notax_type);
    }

    _onChange_personTitle(): void {
        this.addValue(this.personTitle);

    }

    _onChange_nobilityPredicate(): void {
        this.addValue(this.nobilityPredicate);
    }

    _onChange_firstName(): void {
        this.addValue(this.firstName);
    }

    _onChange_nameSuffix(): void {
        this.addValue(this.nameSuffix);
    }

    _onChange_namePreposition(): void {
        this.addValue(this.namePreposition);
    }

    _onChange_surname(): void {
        this.addValue(this.surname);
    }

    _onChange_artistName(): void {
        this.addValue(this.artistName);
    }

    _onChange_organizationName(): void {
        this.addValue(this.organizationName);
    }

    _onChange_isTaxAddress_residenceAddress(): void {

        if (this.isTaxAddress_residenceAddress.checked != true) {
            this.UiModder.domClass.remove(this.addressData_residence_container, "w3-hide");
            this.addValue(this.addressData_residence);
        } else {
            this.UiModder.domClass.add(this.addressData_residence_container, "w3-hide");
            delete this.allValues["addressData_residence"];
        }

        this.addValue(this.isTaxAddress_residenceAddress);
    }

    _onChange_phone_mobile(): void {
        this.addValue(this.phone_mobile);
    }

    _onChange_phone_landLine(): void {
        this.addValue(this.phone_landLine);
    }

    _onChange_phone_other(): void {
        this.addValue(this.phone_other);
    }

    _onChange_phone_organization_central(): void {
        this.addValue(this.phone_organization_central);
    }

    _onChange_email(): void {
        this.addValue(this.email);
    }

    _onChange_email_2(): void {
        this.addValue(this.email_2);
    }

    _onChange_taxNumber(): void {
        this.addValue(this.taxNumber);
    }

    _onChange_UID(): void {
        this.addValue(this.UID);

    }

    _onChange_isVAT(): void {

        if (this.isVAT.checked != true) {
            this.UiModder.domClass.remove(this.Edit_reasonForVATExc, "w3-hide");
            this.addValue(this.reasonForVATExc);
        } else {
            this.UiModder.domClass.add(this.Edit_reasonForVATExc, "w3-hide");
            delete this.allValues["reasonForVATExc"];
        }

        this.addValue(this.isVAT);

    }

    _onChange_taxId_german(): void {
        this.addValue(this.taxId_german);
    }

    _onChange_otherTaxId_type(): void {
        this.addValue(this.otherTaxId_type);
    }

    _onChange_otherTaxId_number(): void {
        this.addValue(this.otherTaxId_number);
    }

    _onChange_company_otherTaxId_type(): void {
        this.addValue(this.company_otherTaxId_type);
    }

    _onChange_company_otherTaxId_number(): void {
        this.addValue(this.company_otherTaxId_number);
    }

    _onChange_reasonForVATExc() {
        this.addValue(this.reasonForVATExc);
    }

    _onChange_AccountHolder(): void {
        this.addValue(this.AccountHolder);

    }

    _onChange_isIBAN_Account(): void {
        this.addValue(this.isIBAN_Account);
        let accHolder: string;


        this.UiModder.domClass.remove(this.Edit_AccountHolder, "w3-hide");

        if (this.isIBAN_Account.getValue() == "yes") {

            this.BIC_SWIFT.setLabel("BIC/SWIFT"); // Kundenvorlage im Detail nachgebaut

            this.UiModder.domClass.remove(this.Edit_AccountHolder_row, "m6");
            this.UiModder.domClass.add(this.Edit_BankAccNumber, "w3-hide");
            this.UiModder.domClass.add(this.Edit_AccountHolder_row, "m12");
            this.UiModder.domClass.add(this.Edit_RoutingNumber, "w3-hide");


            this.UiModder.domClass.remove(this.IbanInput_IBAN, "w3-hide");
            this.UiModder.domClass.add(this.ifNotIBAN, "w3-hide");
            this.UiModder.domClass.add(this.Edit_BankAccNumber, "w3-hide");

        } else {

            this.BIC_SWIFT.setLabel("SWIFT/BIC"); // Kundenvorlage im Detail nachgebaut

            this.UiModder.domClass.remove(this.Edit_BankAccNumber, "w3-hide");
            this.UiModder.domClass.remove(this.Edit_AccountHolder_row, "m12");
            this.UiModder.domClass.add(this.Edit_AccountHolder_row, "m6");
            this.UiModder.domClass.remove(this.Edit_RoutingNumber, "w3-hide");

            this.UiModder.domClass.add(this.IbanInput_IBAN, "w3-hide");
            this.UiModder.domClass.remove(this.ifNotIBAN, "w3-hide");
            this.UiModder.domClass.remove(this.Edit_BankAccNumber, "w3-hide");

        }

    }


    _onChange_IBAN(): void {
        this.addValue(this.IBAN);

    }

    _onValidationREsponse_Iban(evt: Event): void {
        if (evt["isValid"] === true) {
            this.addValue(this.IBAN);
        } else {
            delete this.allValues['IBAN'];
        }
    }

    _onChange_bankName(): void {
        this.addValue(this.bankName);

    }

    _onChange_bankAddress(): void {
        this.addValue(this.bankAddress);
    }

    _onChange_bankAccNumber(): void {
        this.addValue(this.bankAccNumber);
    }

    _onChange_BIC_SWIFT(): void {
        this.addValue(this.BIC_SWIFT);
    }

    _onChange_routingNumber(): void {
        this.addValue(this.routingNumber);
    }

    _onChange_otherBankInformation(): void {
        this.addValue(this.otherBankInformation);

    }

    _onUploadFile(): void {
        this.addValue(this.documents_upload);

    }

    _onUploadPassport(): void {
        this.addValue(this.passport_upload);
    }

    _onChange_newsletter(): void {
        this.addValue(this.newsletter);

    }

    _onChange_dataProcessing(): void {
        this.addValue(this.dataProcessing);

    }

    _onChange_addressData_tax(): void {
        this.addValue(this.addressData_tax);
    }

    _onChange_addressData_residence(): void {
        this.addValue(this.addressData_residence);
    }

    _onChange_train_bonuscard_type(): void {
        this.addValue(this.train_bonus_card_type);
    }

    _onBlur_miscellaneous(): void {

        let textareaValue = this.miscellaneous.value;

        if (textareaValue) {
            this.allValues["miscellaneous"] = textareaValue;
        } else {
            delete this.allValues["miscellaneous"];
        }


    }

    _onChange_organisationMember(): void {

        this.addValue(this.organisationMember)

    }

    _onChange_web(): void {
        this.addValue(this.web);
    }

    _onChange_legalRegistrationInstitution(): void {
        this.addValue(this.legalRegistrationInstitution);
    }

    _onChange_legalRegistrationNumber(): void {
        this.addValue(this.legalRegistrationNumber);
    }

    _onClick_Submit_Button(): void {

        if (this._submitTimeout != null) {
            clearTimeout(this._submitTimeout);
            this._submitTimeout = null;
        }

        this._submitTimeout = setTimeout(lang.hitch(this, function () {
            this.prepareData();
        }), 500);

    }

    // Events ----------------------------------------- END

    prepareData(): void {

        console.log("FORMDATA: ", this.allValues);

        this._sanitiseAllValues();

        // Dialog für bestätigung / Editierung bauen
        if (this.dataCompletnessCheck()) {

            //damit wir eine fixe reihenfolge haben

            let text: string = "<b>" + this.translations["ArtistRegistration__checkYourData"] + ":<b><br><br><br>"

            for (let dataProperty of this.allDataProperties) {

                for (let property in this.allValues) {

                    if (dataProperty == property) {

                        switch (property) {
                            case "language":
                                text += this.translations["ArtistRegistration__generic_language"] + ": " + this.allValues[property] + "<br><br>"
                                break;
                            case "isOrganization":
                                if (this.allValues[property] == "person") {
                                    text += this.translations["ArtistRegistration__generic_person"] + "<br><br>";
                                } else {
                                    text += this.translations["ArtistRegistration__generic_organisation"] + "<br><br>"
                                }
                                break;

                            case "addressData_residence":
                                text += this.translations["ArtistRegistration__residenceAddress"] + ":<br>"
                                let addressFields_residence: Array<string> = ["addressInformation_1", "addressInformation_2", "addressInformation_3", "settlement", "postalCode", "province", "country"];

                                for (let addressField of addressFields_residence) {
                                    if (this.allValues[property][addressField]) {
                                        if (addressField == "country") {
                                            text += this.translations["AdressBlock__country_label"] + ": " + this.allValues[property][addressField] + "<br>";
                                        } else {
                                            text += this.allValues[property][addressField] + "<br>";
                                        }
                                    }
                                }

                                text += "<br>";

                                break;

                            case "addressData_tax":
                                text += this.translations["ArtistRegistration__taxAddress"] + ":<br>"

                                let addressFields_tax: Array<string> = ["addressInformation_1", "addressInformation_2", "addressInformation_3", "settlement", "postalCode", "province", "country"];

                                for (let addressField of addressFields_tax) {
                                    if (this.allValues[property][addressField]) {

                                        if (addressField == "country") {
                                            text += this.translations["AdressBlock__country_label"] + ": " + this.allValues[property][addressField] + "<br>";
                                        } else {
                                            text += this.allValues[property][addressField] + "<br>";
                                        }
                                    }
                                }

                                text += "<br>";
                                break;

                            case "organisationMember":
                                text += "<br>" + this[property].getLabel() + ":<br><br>"

                                let organisationMemberFields: Array<string> = ["Person_interpret", "Person_contactPerson", "Person_function", "Person_gender", "Person_title", "Person_nobilityPredicate", "Person_firstName", "Person_namePreposition", "Person_surname", "Person_nameSuffix", "Person_artistName", "Person_phone_mobile", "Person_phone_landLine",
                                    "Person_phone_other", "Person_email", "Person_email_2"]

                                for (let i = 0; i < this.allValues[property].length; i++) {

                                    let person: object = this.allValues[property][i]

                                    for (let objProperty of organisationMemberFields) {
                                        if (objProperty in person) {
                                            if (objProperty == "Person_interpret" || objProperty == "Person_contactPerson") {
                                                if (person[objProperty]) {
                                                    text += this[property].allRows[0][objProperty].getLabel() + "<br>";
                                                }
                                            } else {
                                                text += this[property].allRows[0][objProperty].getLabel() + ": " + person[objProperty] + "<br>"
                                            }
                                        }
                                    }

                                    text += "<br>";
                                }

                                text += "<br><br>";
                                break;
                            case "train_bonus_card_type":
                                text += this.translations["ArtistRegistration__trainBonuscardType_label"] + ": " + this.allValues[property]["label"] + "<br><br>";
                                break;
                            case "miscellaneous": // ist kein Widget --> hat kein getLabel()
                                text += this.translations["ArtistRegistration__miscellaneous_label"] + ": " + this.allValues[property] + "<br><br>"
                                break;

                            case "documents_upload":
                                text += this.translations["ArtistRegistration_confirmationDialog_furtherDocuments"] + ": ";
                                let filenames: Array<string> = this.documents_upload.getUploadedFilenames();
                                for (let i = 0; i < filenames.length; i++) {
                                    if (i == filenames.length - 1) {
                                        text += filenames[i] + ".";
                                    } else {
                                        text += filenames[i] + ", ";
                                    }
                                }
                                text += "<br><br>"
                                break;

                            case "passport_upload":
                                text += this.translations["ArtistRegistration_confirmationDialog_passport"] + ": ";
                                let passport_files: Array<string> = this.passport_upload.getUploadedFilenames();
                                for (let i = 0; i < passport_files.length; i++) {
                                    if (i == passport_files.length - 1) {
                                        text += passport_files[i] + ".";
                                    } else {
                                        text += passport_files[i] + ", ";
                                    }
                                }
                                text += "<br><br>"
                                break;

                            case "newsletter":
                                if (this.allValues["newsletter"]) {
                                    text += this.translations["ArtistRegistration__newsletter"] + "<br><br>";
                                }
                                break;
                            case "isVAT":
                                if (this.allValues["isVAT"] === true) {
                                    text += this.translations["ArtistRegistration__isVAT"] + "<br><br>"
                                }

                            case "email":

                                if (typeof this.allValues[property] == "object") {
                                    if (this[property].getLabel()) {
                                        text += this[property].getLabel() + ": " + this.allValues[property]["email_address"] + "<br><br>"
                                    } else {
                                        console.log("no label for ", property);
                                    }
                                } else {
                                    if (this[property].getLabel()) {
                                        text += this[property].getLabel() + ": " + this.allValues[property] + "<br><br>"
                                    } else {
                                        console.log("no label for ", property);
                                    }
                                }
                                break;
                            case "email_2":
                                if (typeof this.allValues[property] == "object") {
                                    if (this[property].getLabel()) {
                                        text += this[property].getLabel() + ": " + this.allValues[property]["email_address"] + "<br><br>"
                                    } else {
                                        console.log("no label for ", property);
                                    }
                                } else {
                                    if (this[property].getLabel()) {
                                        text += this[property].getLabel() + ": " + this.allValues[property] + "<br><br>"
                                    } else {
                                        console.log("no label for ", property);
                                    }
                                }
                                break;

                            case "isTaxAddress_residenceAddress":
                                break;

                            default:
                                if (this[property].getLabel()) {
                                    text += this[property].getLabel() + ": " + this.allValues[property] + "<br><br>"
                                } else {
                                    console.log("no label for ", property);
                                }
                        }
                    }
                }
            }

            /// sterne für obligatorische felder entfernen
            let finalText: string = text.replace(/\s\*/g, "");
            finalText = finalText.replace(/\*/g, "");

            let dlg = new GenericDialog();
            dlg.set("header", this.translations["ArtistRegistration__checkYourData_header"]);

            dlg.textNode.innerHTML = finalText;

            dlg.setUserdefinedButton(this.translations["ArtistRegistration__checkYourData_send"], "", lang.hitch(this, function () { this.sendData(this.allValues); }), true);

            dlg.set("back", true);

            dlg.open();

        }
    }


    setValues(data: object): void {

        if (typeof data === 'object' && JSON.stringify(data) !== '{}') {
            this.allValues = data;
            for (let input in data) {

                if (input == 'language') {
                    continue;
                }
                this[input].setValue(data[input]);
            }
        }

    }

    // check if all the data has been submited
    dataCompletnessCheck(): boolean {

        let result = true;
        let mandatoryKeys = this.mandataoryFields;

        if (this.allValues['isOrganization'] === 'organisation') {
            mandatoryKeys = mandatoryKeys.concat(this.organization_fields);
            /*if (this.allValues["language"] == "de") {
                mandatoryKeys = mandatoryKeys.concat(this.germanOrganisation_fields);
            }*/
        } else {
            mandatoryKeys = mandatoryKeys.concat(this.person_fields);
        }

        if (this.allValues['isTaxAddress_residenceAddress'] === false) {
            mandatoryKeys = mandatoryKeys.concat(this.taxAddress_IsNot_ResidenceAdress_Fields);

        }

        let text: string = "";


        for (let i = 0; i < mandatoryKeys.length; i++) {

            this[mandatoryKeys[i]].validateInput();

            if (!this.allValues.hasOwnProperty(mandatoryKeys[i])) {
                result = false;
                console.log("missing property: ", mandatoryKeys[i]);
                text += this[mandatoryKeys[i]].getLabel() + "<br>";
            }
        }


        if (result === false) {
            let dlg = new GenericDialog();
            dlg.set("header", this.translations["ArtistRegistration__incompleteData_header"]);
            dlg.textNode.innerHTML = window.translations["ArtistRgistration__incompletData"] + "<br><br> <b>" + window.translations["ArtistRgistration__obligatoryFields"] + ": </b> <br>" + text;
            dlg.set("close", true);
            dlg.open();
        }

        return result;
    }


    // Add/delete Input values to/in this.allValues bei inputNode._onValueChange Event von jedem Input
    addValue(input: any): void {
        let value: string | object = input.getValue();

        if (typeof value == "string") value = value.trim();

        let widgetAttachPoint: string = this.getAttachPointNameForWidget(input);

        let isDataValid:boolean;

        //modifizierung für orgnisationMember

        if (input.dataCompletenessCheck) {
            isDataValid = input.dataCompletenessCheck();
        } else {
            isDataValid = input.isValid;
        }


        if (value != null && value != "" && isDataValid) {

            if (widgetAttachPoint == "email" || widgetAttachPoint == "email_2") {
                if (this.allValues["originEmail"] && this.allValues["originEmail"].email_address == value) {
                    value = { ID: this.allValues["originEmail"].ID, email_address: this.allValues["originEmail"].email_address }
                }
            } else if (widgetAttachPoint == "train_bonus_card_type") {
                value = { ID: value, label: this.train_bonus_card_type.getValue(true) };
            }

            this.allValues[widgetAttachPoint] = value;

        } else {
            delete this.allValues[widgetAttachPoint];
        }
    }

    getAttachPointNameForWidget(widget: MdsLax<InstanceType<typeof _StatefulBase>>): string {
        for (let attachPointName of this._attachPoints) {
            if (this[attachPointName] == widget) {
                return attachPointName;
            }
        }
    }



    // Request --------------------------------------------------- START

    getEntityId(guid: string): void {

        let requestUrl: string = null;

        requestUrl = window.appRoot + "ArtistRegistration/GetEntityIdByGuid";

        // identifyer?
        let requestParams = {
            "jsonData": guid
        };

        this.__request = this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, this._onGetEntityIdResponse),
            lang.hitch(this, this._onGetEntityIdError)
        );

    }

    _onGetEntityIdResponse(response:any): void {

        console.log("_onGetEntityIdResponse:  ", response);

        if (response && response.EntityID) {

            if (response["email_ID"] && response["email_address"]) {
                this.allValues["originEmail"] = { ID: response.email_ID, email_address: response.email_address };
                this.email.setValue(response.email_address);
            }

            if (response.Classname && response.Classname == "persons") {
                this.allValues["entityID_Person"] = response.EntityID;
                this.isOrganization.setValue("person");
                this._onChange_isOrganization();

                if (response.firstName) {
                    this.firstName.setValue(response.firstName);
                }
                if (response.surname) {
                    this.surname.setValue(response.surname);
                }

            } else if (response.Classname && response.Classname.indexOf("organisation") != -1) {

                this.allValues["entityID_Organisation"] = response.EntityID;
                this.isOrganization.setValue("organisation");
                this._onChange_isOrganization();

                if (response.organisationName) {
                    this.organizationName.setValue(response.organisationName);
                }

            } else {
                console.log("_onGetEntityIdResponse:: invalid Entity Class: ", response.Classname);
            }
        }
    }

    _onGetEntityIdError(e): void {
        console.log(e);
    }

    sendData(data: object): void {







        console.log(data);
        //return;








        data["validationGUID"] = this.validationGUID;

        let requestUrl: string = null;

        if (this.controllerUrl) {
            requestUrl = window.appRoot + this.controllerUrl;
        } else {
            console.log('Controller Url for this Form is NULL!')
            return;
        }

        // identifyer?
        let requestParams = {
            "jsonData": JSON.stringify(data)
        };

        this.__request = this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, this._onSendDataResponse),
            lang.hitch(this, this._onSendDataError)
        );

        //this._onSendDataResponse();
    }

    // Response optional for DEVELOPMENT
    _onSendDataResponse(response?: object): void {

        if (response) {
            if (!response["Exception"]) {
                window.removeEventListener("beforeunload", this.beforeOnloadEventFunction);


                this.emit('dataSent_Success');

                alert('Data sent successfully');

                this.RequestManager.post(window.appRoot + "session/close",
                    {
                        "sessionid": window["sessionInfo"].sessionData.Session.Id
                    },
                    lang.hitch(this, "_onCloseSessionResponse"),
                    lang.hitch(this, "_onCloseSessionError")
                );

                // Redirect?
            } else {
                alert("ERROR: check console for more details");
                console.log("response ERROR: ", response )
            }
        }


    }
    _onCloseSessionError(err) {
        location.replace("https://www.humboldtforum.org/");
    }
    _onCloseSessionResponse(response) {
        location.replace("https://www.humboldtforum.org/");
    }

    _onSendDataError(err: object): void {

        console.log('ERROR:', err);

    }

    // Request ----------------------------------------------------END

    // Styling ---------------------------------------------------START
    animateInput(node: HTMLInputElement): void {
        if (screen.width > 600) {
            this.UiModder.domClass.add(node, "w3-animate-input");
            this.UiModder.domStyle.set(node, "width", "48.5%");
        } else {
            this.UiModder.domClass.remove(node, "w3-animate-input");
            this.UiModder.domStyle.set(node, "width", "100%");
        }
    }

    // Styling ---------------------------------------------------END

    // PrivacyPolicy ------------------------------------------------------START

    _setDataProcessingLabel(): void {
        let labelTemplate: string = this.translations["ArtistRegistration__dataProcessing"];

        if (!labelTemplate) {
            alert("No Template Translation for ArtistRegistration__dataProcessing");
            return;
        }
        labelTemplate = labelTemplate.replace(/\\'/g, "\'");
        let templateParts :Array<string> = labelTemplate.split(":::LINK:::"); // Ich habe die :::LINK::: gelesen und erkenne diese ausdrücklich an.

        let dialogLink = this.UiModder.domConstruct.create("a", {
            href: "#",
            onclick: lang.hitch(this, function (evt) {
                evt.preventDefault();
                evt.stopPropagation();
                this._onclickPrivacyPolicyLink(evt);
            }),
            innerHTML: this.translations["ArtistRegistration__privacyPolicy_link_innerHTML"],
        });


        let firstPart = this.UiModder.domConstruct.create("span", {
            innerHTML: templateParts[0]
        });

        let lastPart = this.UiModder.domConstruct.create("span", {
            innerHTML: templateParts[1]
        });

        this.dataProcessing.setLabel(firstPart.outerHTML + dialogLink.outerHTML + lastPart.outerHTML);
    }

    _onclickPrivacyPolicyLink(evt): void {

        console.log("_onclickPrivacyPolicyLink: ", evt);

        let dlg: MdsLax<InstanceType<typeof GenericDialog>> = new GenericDialog();
        let textTemplate: string = this.translations["ArtistRegistration__privacyPolicy_dialogText_body"];
        textTemplate = textTemplate.replace(/\\'/g, "\'");
        let user = this.translations["ArtistRegistration__privacyPolicy_dialogText_mailtoLink_user"];
        let domain = this.translations["ArtistRegistration__privacyPolicy_dialogText_mailtoLink_domain"];
        let contentParts: Array<string> = textTemplate.split(":::MAILTO:::");

        let mailtoLink = this.UiModder.domConstruct.create("a", {
            href: "mailto:" + user + "@" + domain,
            onclick: lang.hitch(this, function (evt) {
                window.removeEventListener("beforeunload", this.beforeOnloadEventFunction);
                evt.stopPropagation();
            }),
            innerHTML: user + "@" + domain,
        }, dlg.textNode);

        this.UiModder.domConstruct.create("span", {
            innerHTML: contentParts[0]
        }, dlg.textNode, "first");

        this.UiModder.domConstruct.create("span", {
            innerHTML: contentParts[1]
        }, dlg.textNode, "last");

        dlg.set("header", this.translations["ArtistRegistration__privacyPolicy_dialog_header"]);
        dlg.set("close", true);

        dlg.on("closed", lang.hitch(this, function () {
            window.removeEventListener("beforeunload", this.beforeOnloadEventFunction);
            window.addEventListener("beforeunload", this.beforeOnloadEventFunction);
        }))
        dlg.open();
    }

    // PrivacyPolicy ------------------------------------------------------END

    private _onGetTrainBonusCardTypesResponse(response) {
        this.train_bonus_card_type.setBlankOption("", "----", true);
        for (let entry of response) {
            this.train_bonus_card_type.addEntry(entry.ID, entry.description);
        }
        this.train_bonus_card_type.constructOptions();
    }
    private _onGetTrainBonusCardTypesError(error) {
        console.log(error);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this.translations["ArtistRegistration__documentsUpload_note"] = this.translations["ArtistRegistration__documentsUpload_note"].replace("\\\\\'", "\\'");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        // file upload custom buttons

        this.passport_upload.setCustomLabels("ArtistRegistration__uploadPassport");
        //this.passport_upload.customFileUploadButton(true);
        //this.passport_upload.setInputButton_label(window.translations['ArtistRegistration__uploadPassport']);

        this.documents_upload.setCustomLabels("ArtistRegistration__selectFile");
        //this.documents_upload.customFileUploadButton(true);
        //this.documents_upload.setInputButton_label(window.translations['ArtistRegistration__selectFile']);

        // set label programmatically because contains markup
        this._setDataProcessingLabel();

        // wenn eine sprache ausgewählt ist, soll sie gesetzt werden
        if (this.getUrlParameterValue("lang")) {
            this.setLanguageSelect();
        } else {
            this.setLanguageSelect("en");
        }

        window.addEventListener("beforeunload", this.beforeOnloadEventFunction);

        // person vorauswählen

        this.isOrganization.selectOptionByName("person");
        this.allValues[this.getAttachPointNameForWidget(this.isOrganization)] = this.isOrganization.getValue();

        // bank acc mit IBAN auswählen
        this.isIBAN_Account.selectOptionByName("yes");
        this.allValues[this.getAttachPointNameForWidget(this.isIBAN_Account)] = this.isIBAN_Account.getValue();

        // gender selects
        this.gender.setValue("", true, true, null, true); // selectBox.setValue(newValue: string, bSuppressChange?: boolean, forceIfDisabled?: boolean, bSupressValidation?:boolean, delimiter?: string)

        // set the phone inputs to correct placeholders (Mobile is default)
        this.phone_organization_central.setPlaceholderNumberType("FIXED_LINE");
        this.phone_landLine.setPlaceholderNumberType("FIXED_LINE");

        let langCode = window.currentLanguageCode2;
        if(langCode == "en" ){
            langCode = "gb";
        }

        if( langCode != "de" ) {
            this.phone_mobile.setCountry(langCode);
            this.phone_landLine.setCountry(langCode);
            this.phone_organization_central.setCountry(langCode);
            this.phone_other.setCountry(langCode);
        }else{
            this.phone_mobile.setCountry("gb");
            this.phone_landLine.setCountry("gb");
            this.phone_organization_central.setCountry("gb");
            this.phone_other.setCountry("gb");

            // russischer workaround weil durch separateDialCode das deutsche input 100% breite bekommt?!?!? keine ahnung warum nur bei .de
            setTimeout(lang.hitch(this, function(){
                this.phone_mobile.setCountry("de");
                this.phone_landLine.setCountry("de");
                this.phone_organization_central.setCountry("de");
                this.phone_other.setCountry("de");
            }), 1000);
        }


        // mobile layout correction
        if (window.screen.width < 650) {
            this.isOrganization.setAlignment("vertical");
        }

        if (window.screen.width < 500) {
            this.UiModder.domStyle.set(this.fileUpload_container, "display", "");
        } else {
            this.UiModder.domStyle.set(this.fileUpload_container, "display", "flex");
        }

        // get the guid
        this.validationGUID = this.getUrlParameterValue("guid");

        this.getEntityId(this.validationGUID);

        this.addValue(this.taxrate);


        //Get train bonus card types
        this.RequestManager.get(window.appRoot + "ArtistRegistration/GetTrainBonusCardTypes", lang.hitch(this, this._onGetTrainBonusCardTypesResponse), lang.hitch(this, this._onGetTrainBonusCardTypesError));
    }
}

export default mdsWidget(ArtistRegistration);
